import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueueService<T> implements IQueue<T> {
  private storage: T[] = [];
  private capacity: number = Infinity;
  constructor() {}

  enqueue(item: T): void {
    if (this.size() === this.capacity) {
      throw Error("Queue has reached max capacity, you cannot add more items");
    }
    this.storage.push(item);
  }
  dequeue(): T | undefined {
    return this.storage.shift();
  }
  size(): number {
    return this.storage.length;
  }
  clear(): void{
    this.storage = [];
  }

  exists(item: T): boolean{
    for (let currItem of this.storage){
      if (currItem == item){
        return true;
      }
    }

    // no item was found
    return false;
  }
}

interface IQueue<T> {
  enqueue(item: T): void;
  dequeue(): T | undefined;
  size(): number;
}